import React from 'react'
import Transition from 'react-transition-group/Transition'

import enhance from './enhance'
import { AccordionItem, Icon, Label, Content } from './styles'

const defaultStyle = {
  transition: `all 0.2s`,
  maxHeight: 0,
  overflow: 'hidden',
  opacity: 0,
}

const transitionStyles = {
  entering: {
    maxHeight: 0,
    opacity: 0,
  },
  entered: {
    maxHeight: '75rem',
    opacity: 1,
  },
}

const Component = ({
  label,
  children,
  handleToggle,
  isExpanded,
  className,
  labelClassName,
  iconOnRight,
  hasColor,
  noBorder,
  testId,
}) => (
  <AccordionItem
    isExpanded={isExpanded}
    data-open={isExpanded}
    iconOnRight={iconOnRight}
  >
    <Label
      onClick={handleToggle}
      expanded={isExpanded}
      iconOnRight={iconOnRight}
      hasColor={hasColor}
      noBorder={noBorder}
      className={labelClassName}
      data-testid={testId + 'Label'}
    >
      {iconOnRight ? (
        <React.Fragment>
          {label}
          <Icon name={isExpanded ? 'minus' : 'dropdown'} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Icon name={isExpanded ? 'minus' : 'plus'} />
          {label}
        </React.Fragment>
      )}
    </Label>
    {children && (
      <Transition in={isExpanded} timeout={0}>
        {state => (
          <div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <Content
              isExpanded={isExpanded}
              className={className}
              hasColor={hasColor}
              data-testid={testId + 'Content'}
            >
              {children}
            </Content>
          </div>
        )}
      </Transition>
    )}
  </AccordionItem>
)

export default enhance(Component)
